export enum ContractType {
    PJ = 1,
    CLT = 2,
    Estagiario = 3,
    Outros = 4
}


// WEBPACK FOOTER //
// ./src/app/shared/enums/ContractType.ts